import { omit } from 'lodash';
import { graphql } from '@/gql';
import type { UpdateLovedOneMutation, UpdateLovedOneMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type UpdateLovedOneInput = UpdateLovedOneMutationVariables;

export type UpdateLovedOneOutput = UpdateLovedOneMutation['updateLovedOne'];

export const updateLovedOne = async ({ id, data }: UpdateLovedOneInput): Promise<UpdateLovedOneOutput> => {
  const inputData = omit(data, ['phoneInfo', 'id']);

  const response = await mutationExecute({
    mutation: graphql(`
      mutation UpdateLovedOne($data: LovedOneInputType!, $id: String!) {
        updateLovedOne(data: $data, id: $id) {
          id
        }
      }
    `),
    variables: {
      id,
      data: inputData,
    },
  });

  return response.data?.updateLovedOne;
};
